import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsSubComponent, PmsSubComponent } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsSubComponent>
    useData={usePmsSubComponent}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
